var collItemsPerPage = document.getElementById('items-per-page');
if (collItemsPerPage) {
	collItemsPerPage.addEventListener('change', function (evt) {
		let data = {
			attributes: {
				pagination: this.value
			}
		};

		fetch(window.Shopify.routes.root + 'cart/update.js', {
			method: "POST",
			headers: {
				'Content-Type': 'application/json'
			},
			body: JSON.stringify(data)
		}).then(response => {
			window.location.reload();
		}).catch(error => {
			console.error('Error', error);
		});
	});
}

const collFilterInputs = document.querySelectorAll('.filter-checkbox');
const collSortby = document.querySelector('#sort-by');
if (collFilterInputs && collSortby) {
	function collUpdateQuery() {
		var queryString = '';
		var selectedInputs = document.querySelectorAll('.filter-checkbox:checked');
		selectedInputs.forEach((el, i) => {
			var name = el.getAttribute("name");
			var paramObj = {};
			paramObj[name] = el.value;
			var params = new URLSearchParams(paramObj).toString();
			params = (i == 0) ? params : '&' + params;
			queryString += params;
		});
		var sortByObj = { sort_by: collSortby.value };
		queryString += ((queryString !== '') ? '&' : '') + (new URLSearchParams(sortByObj)).toString();
		if (location.pathname == '/search' || location.pathname == '/en-ca/search' || location.pathname == '/en-row/search') {
			var urlParams = new URL(window.location.toLocaleString()).searchParams;
			var seachQuery = 'q=' + urlParams.get('q') + '&type=' + urlParams.get('type') + '&';
			queryString = seachQuery + queryString;
		}
		if (queryString !== '') {
			location.search = queryString.replace(/%2B/g, '+');
		} else {
			location = location.pathname;
		}
	}

	collFilterInputs.forEach((el) => {
		el.addEventListener('change', function (e) {
			collUpdateQuery();
		});
	});

	collSortby.addEventListener('change', function (e) {
		collUpdateQuery();
	});
}

const collFilters = document.querySelector('#main-collection-filters .filter-form');
const collFilterBtn = document.getElementById('filter-display-mobile');

if (collFilters && collFilterBtn) {
	function collPositionMobileFilter() {
		var top = window.pageYOffset + collFilterBtn.getBoundingClientRect().top + collFilterBtn.clientHeight;
		collFilters.style.top = top + 'px';
	}
	collFilterBtn.addEventListener('click', function (e) {
		if (!collFilters.classList.contains('active')) {
			e.target.setAttribute('aria-expanded', 'true');
			collFilters.classList.add('active');
			collPositionMobileFilter();
		} else {
			e.target.setAttribute('aria-expanded', 'false');
			collFilters.classList.remove('active');
		}
	});

	window.addEventListener("resize", function (e) {
		if (collFilters.display == 'none') {
			collFilterBtn.setAttribute('aria-expanded', 'false');
		} else {
			collFilterBtn.setAttribute('aria-expanded', 'true');
			collPositionMobileFilter();
		}
	});
}

function checkForFilterChanges() {
	const mainCollectionFilters = document.querySelector('#main-collection-filters');

	if (!mainCollectionFilters) { return; }

	const observer = new MutationObserver(onFilterChange);

	observer.observe(mainCollectionFilters, {
		childList: true,
		subtree: true
	});
}

function onFilterChange() {
	fetch(window.location.href)
		.then((response) => response.text())
		.then((responseText) => {
			const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
			const currentCollectionTitleEl = document.querySelector('h1.main-collection__title');
			const newCollectionTitleEl = responseHTML.querySelector('h1.main-collection__title');
			const currentTitleEl = document.querySelector('head > title');
			const newTitleEl = responseHTML.querySelector('head > title');

			if (currentCollectionTitleEl && newCollectionTitleEl) {
				updateCollectionHeading(currentCollectionTitleEl, newCollectionTitleEl);
			}

			if (currentTitleEl && newTitleEl) {
				updatePageTitle(currentTitleEl, newTitleEl);
			}
		})
		.catch((error) => {
			console.error('Error fetching collection on filter change', error);
		});
}

function updateCollectionHeading(currentCollectionTitleEl, newCollectionTitleEl) {
	currentCollectionTitleEl.innerHTML = newCollectionTitleEl.innerHTML;
}

function updatePageTitle(currentTitleEl, newTitleEl) {
	currentTitleEl.innerHTML = newTitleEl.innerHTML;
}

document.addEventListener('DOMContentLoaded', function () {
	checkForFilterChanges();
	var swiper = new Swiper(".enhanced-collection-links .swiper", {
		scrollbar: {
			el: ".swiper-scrollbar",
			hide: true,
			draggable: true
		},
		spaceBetween: 16,
		mousewheel: {
			forceToAxis: true,
		},
		slidesPerView: 'auto',
		navigation: {
			nextEl: ".enhanced-carousel__next",
			prevEl: ".enhanced-carousel__prev"
		},
	});
});
